import {LookupFieldType} from "~/enums/lookupFieldType";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import ModelMappingValueOriginObjectModelProperty from "~/models/mapping/modelMappingValueOriginObjectModelProperty";
import ModelMappingOriginLookupField from "~/models/mapping/modelMappingOriginLookupField";
import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import FormElement from "../../../formability/form_builder/models/formElements/formElement";
import ModelMappingValueOriginFormElement from "~/models/mapping/modelMappingValueOriginFormElement";

export default class ModelMappingValueOriginLookupField extends ModelMappingValueOrigin<ObjectModelProperty, ModelMappingOriginLookupField> {

  get origin(): ObjectModelProperty {
    return this.objectModelProperty
  }

  get value() {
    const parent = this.modelMappingOrigin?.formElementMappingOrigin?.origin
    if (!parent) return {label: ''};
    if (parent.lookup_type === LookupFieldType.licenses) {
      const licenseSourceValue = parent.licenses.find(license => license.client_id === this.id);
      return {label: licenseSourceValue.title}
    } else if (parent.lookup_type === LookupFieldType.objectModels) {
      return this.objectModelPropertyMappingValueOrigin.value
    }
  }

  get valueType(): string {
    if (!this.formElement) return null;
    if (this.formElement.lookup_type === LookupFieldType.licenses) {
      return this.formElementMappingValueOrigin.valueType
    } else {
      return this.objectModelPropertyMappingValueOrigin.valueType
    }
  }

  get isIndexed(): boolean {
    return this.objectModelPropertyMappingValueOrigin?.isIndexed
  }

  get isUploader(): boolean {
    return this.objectModelPropertyMappingValueOrigin?.isUploader
  }

  private get objectModelProperty(): ObjectModelProperty {
    return this.objectModelPropertyMappingValueOrigin.origin
  }

  get objectModelPropertyMappingValueOrigin(): ModelMappingValueOriginObjectModelProperty {
    return new ModelMappingValueOriginObjectModelProperty(this.id, this.modelMappingOrigin.objectModelMappingOrigin)
  }

  get formElement(): FormElement {
    return this.modelMappingOrigin?.formElementMappingOrigin?.origin
  }

  get formElementMappingValueOrigin() {
    if (this.formElement) {
      return new ModelMappingValueOriginFormElement(this.formElement.id, this.modelMappingOrigin.formElementMappingOrigin)
    }
  }

  get isRecordId(): boolean {
    return this.objectModelPropertyMappingValueOrigin?.isRecordId
  }

  get isBuiltIn(): boolean {
    return this.objectModelPropertyMappingValueOrigin?.isBuiltIn
  }

  get isSinglePicklist(): boolean {
    return this.objectModelPropertyMappingValueOrigin?.isSinglePicklist
  }

  get isMultiPicklist(): boolean {
    return this.objectModelPropertyMappingValueOrigin?.isMultiPicklist
  }
}